module.exports = __webpack_public_path__ + "static/media/verification_bg.c544cc51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/verification_bg.png
// module id = 1113
// module chunks = 21